module.exports = __webpack_public_path__ + "img/2019-n.1ec59c60.jpg";